import React from "react"
import { ImportOutlined } from "@ant-design/icons"

import { hasAccess } from "@components/Authorization"

import FailedTransactionsSwitch from "../FailedTransactionsSwitch"

const LABEL_IMPORT = "Import"


const getHeaderActions = (
  openImportModal,
  shouldShowFailedOnly,
  setShouldShowFailedOnly,
  failedTransactionsCount
) => {
  const canCreateTransactions = hasAccess(['transactions-write'])

  const hasFailedTransactions = failedTransactionsCount > 0

  const items = []

  if (hasFailedTransactions) {
    items.push({
      component: (
        <FailedTransactionsSwitch
          isChecked={shouldShowFailedOnly}
          onChange={setShouldShowFailedOnly}
          failedTransactionsCount={failedTransactionsCount}
        />
      ),
    })
  }

  if (canCreateTransactions) {
    items.push({
      icon: <ImportOutlined />,
      action: openImportModal,
      title: LABEL_IMPORT,
    })
  }

  return items
}

export default getHeaderActions
